import { render } from "./ClientsListPage.vue?vue&type=template&id=8b3f8f7e&scoped=true"
import script from "./ClientsListPage.vue?vue&type=script&lang=js"
export * from "./ClientsListPage.vue?vue&type=script&lang=js"

import "./ClientsListPage.vue?vue&type=style&index=0&id=8b3f8f7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b3f8f7e"]])

export default __exports__